import { useMutation, useQueryClient } from '@tanstack/react-query';
import axiosInstance from '../../../constants/axiosInstance';
import { trackEvent } from '../../../modules/analytics/trackingMiddleware';
import { INSIGHTS_COMMENT_ADDED } from '../../../modules/analytics/events';

interface PostCommentPayload {
  insightId: string;
  comment: string;
}

interface PostCommentResponse {
  message: string;
  data: {
    insightId: string;
    senderId: string;
    comment: string;
    isArchived: boolean;
    _id: string;
    createdAt: string;
    updatedAt: string;
    __v: number;
  };
}

const postInsightComment = async ({
  insightId,
  comment,
}: PostCommentPayload): Promise<PostCommentResponse> => {
  const { data } = await axiosInstance().post('/insights/createInsightComment', {
    insightId,
    comment,
  });
  return data;
};

export const usePostInsightComment = (insightId: string) => {
  const queryClient = useQueryClient();

  const { mutate, isPending, isSuccess, isError, error } = useMutation({
    mutationFn: (comment: string) => postInsightComment({ insightId, comment }),
    onSuccess: () => {
      trackEvent(INSIGHTS_COMMENT_ADDED, { insightId });
      queryClient.invalidateQueries({ queryKey: ['insightComments', insightId] });
    },
  });

  return {
    postComment: mutate,
    isPosting: isPending,
    isSuccess,
    isError,
    error,
  };
};
